<button
	#button
	mat-raised-button
	[style.height.px]="height + shadowHeight"
	[style.border-radius.px]="radius"
	type="button"
	(click)="buttonClicked($event)"
	[disabled]="disabled"
	[style.width.px]="width || '100%'"
	[class]="_theme"
>
	<div class="inner" [ngClass]="color" [style.border-radius.px]="radius">
		<div class="busy" *ngIf="busy">
			<mat-spinner [diameter]="27" [strokeWidth]="4"></mat-spinner>
		</div>
		<div class="content" [style.padding-left.px]="contentPadding" [style.padding-right.px]="contentPadding" *ngIf="!busy">
			<img *ngIf="iconImage && !after" [src]="iconImage" />
			<ng-content></ng-content>
			<img *ngIf="iconImage && after" class="after" [src]="iconImage" />
		</div>
	</div>
</button>
